module.exports = __webpack_public_path__ + "img/69.b9cdd901.png";